import React from "react"
import { useParams } from "react-router-dom"
import { Text, Box } from "@chakra-ui/react"
import EditorSection from "components/Builder/components/EditorSection"
import { Form } from "sharedTypes"
import LanguageTemplateReference from "components/settings/LanguageTemplateReference"

type Props = {
  form: Form
}

const MessagingSection = ({ form }: Props) => {
  const { eventId } = useParams<{ eventId: string }>()

  return (
    <EditorSection>
      <Box mb={4}>
        <LanguageTemplateReference
          eventId={eventId}
          form={form}
          description={() => (
            <Text>
              The form&apos;s language template controls this text. Changing the template
              updates labels, buttons, terminology, and messages throughout the form.
            </Text>
          )}
        />
      </Box>
    </EditorSection>
  )
}

export default MessagingSection
